import { BlockHeight } from '../models/BlockSettings';
import { verifyObject } from '../utils';

const maxFileSize = parseInt(process.env.REACT_APP_MAX_FILE_SIZE, 10) || 5_242_880;
const maxVideoSize = parseInt(process.env.REACT_APP_MAX_VIDEO_SIZE, 10) || 10_485_760;
const parallaxEffect = parseFloat(process.env.REACT_APP_BACKGROUND_PARALLAX_EFFECT) || 0.2;
const config = {
  env: process.env.REACT_APP_STAGE || 'production',
  encryption: {
    secret: process.env.REACT_APP_ENCRYPTION_SECRET as string,
  },
  api: {
    url: process.env.REACT_APP_API_URL ?? '',
    webdbUrl: process.env.REACT_APP_WEBDB_URL ?? '',
    webdbSsoUrl: process.env.REACT_APP_WEBDB_SSO_URL ?? '',
    max_calls: (parseInt(process.env.REACT_APP_API_MAX_CALLS, 10) || 20) - 1,
    call_interval: (parseInt(process.env.REACT_APP_API_CALL_INTERVAL, 10) || 5) * 1000,
    webdbKeyStorage: 'x2KDEnhTH',
  },
  auth: {
    // TODO: encrypt the key of cookie
    cookieName: 'ksPw4FSNZW',
    webdbStorage: 'v2LHmBeD5VFXK',
  },
  defaultUrlLandingPage: process.env.REACT_APP_AD_HREF,
  defaultImageUrl: 'common/images/sample_image_20230927.jpg',
  plan: {
    informationUrl: process.env.REACT_APP_PLAN_INFORMATION_URL || '',
  },
  image: {
    maxFileSize,
    maxFileSizeInMb: maxFileSize / 1_024 / 1_024,
    fixedAspectRatio: '2.35:1',
    largeFixedAspectRatio: '16:9',
  },
  video: {
    maxVideoSize,
    maxVideoSizeInMb: maxVideoSize / 1_024 / 1_024,
  },
  backgroundImage: {
    parallaxEffect,
  },
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  items: {
    maxLength: 1000,
    delimiter: ',',
    types: {
      empty: {
        value: 0,
        label: 'Blank',
      },
      text: {
        value: 1,
        label: 'Text',
      },
      textarea: {
        value: 2,
        label: 'Textarea',
      },
      date: {
        value: 3,
        label: 'Date/Time',
      },
      checkbox: {
        value: 4,
        label: 'Checkbox',
      },
      select: {
        value: 5,
        label: 'Select',
      },
      group: {
        value: 6,
        label: 'Group',
      },
      number: {
        value: 7,
        label: 'Number',
      },
      map: {
        value: 8,
        label: 'Google Maps',
      },
      youtube: {
        value: 9,
        label: 'YouTube',
      },
      image: {
        value: 10,
        label: 'Image',
      },
      radio: {
        value: 11,
        label: 'Radio button',
      },
      email: {
        value: 12,
        label: 'Email address',
      },
    },
  },
  preview: {
    storageKey: 'inq-prvw',
  },
  deploymentStatus: {
    pending: 1,
    inProgress: 2,
    completed: 3,
    failed: 4,
  },
  webProcesses: {
    publish: 1,
    unpublish: 2,
    republish: 3,
  },
};

// Check if config object is valid and not missing a key
const validate = verifyObject(config);

if (!validate) {
  throw new Error('No valid environment found');
}
if (validate.length !== 0) {
  throw new Error(`Environment variable missing: ${validate}`);
}

export const getFixedAspectRatioValue = (height: BlockHeight) => {
  let fixedAspectRatioValues = config.image.fixedAspectRatio.split(':');
  if (height === BlockHeight.TALL) fixedAspectRatioValues = config.image.largeFixedAspectRatio.split(':');
  return parseFloat(fixedAspectRatioValues[1]) / parseFloat(fixedAspectRatioValues[0]);
};

export default config;
